module.exports = {
  entries: require("./entries"),
  map: require("./map"),
  filter: require("./filter"),
  reduce: require("./reduce"),
  some: require("./some"),
  every: require("./every"),
  pipeline: require("./pipeline"),
  all: require("./all"),
  allValues: require("./allValues")
};
